<div (click)='clickOutSide()' id="wrapper">
    <sn-toasts aria-live="polite" aria-atomic="true"></sn-toasts>
    <sn-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
    </sn-topbar>

    <sn-leftsidebar [sidebarType]="sidebarType"></sn-leftsidebar>

    <div class="content-page">
        <div class="content">
            <!-- content -->
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
